export const modalDataLoaderByType = {};
